import { trackEvent } from '../../../../utils/events/trackEvent'

const TAB_OPEN_TIME = new Date()

/**
 * Utility to track logout events.
 *
 * @param isExpired - Whether the logout was due to an expired token.
 */
export const trackLogout = ({ isExpired }: { isExpired: boolean }) => {
  try {
    trackEvent({
      id: 'app.logout',
      description: 'User logged out',
      data: {
        // Allow determining which users are being redirected on opening a new tab vs
        // which users are actively using the tooling
        timeSinceTabOpenMs: new Date().getTime() - TAB_OPEN_TIME.getTime(),
        isExpired,
      },
    })
  } catch (e) {
    // noop
  }
}
